import React from "react";
import { Routes, Route } from "react-router-dom";
import ProtectedRoute from "../components/ProtectedRoute";
import Dashboard from "../containers/Dashboard/Index";
import Home from "../containers/Dashboard/Default";
import UploadModal from "../containers/Modal/UploadModal";
import UploadTranscript from "../containers/Dashboard/UploadTranscript";
import BondDetailsEdit from "../containers/Dashboard/BondDetailsEdit";
import BondCounselUserLandingPage from "../containers/Dashboard/BondCounselUserLandingPage";
import Login from "../containers/Login";
import CreateAccount from "../containers/Account/CreateAccount";
import { LoginCallback } from "@okta/okta-react";
import LogoutSuccess from "../components/LogoutSuccess";
import Contact from "../containers/Contact";

const AllRoutes = () => {
  return (
    <Routes>
      <Route
        exact
        path="/contact"
        element={
          <Contact />
        }
      ></Route>
      <Route
        exact
        path="/"
        element={
          <ProtectedRoute>
            {" "}
            <Dashboard />
          </ProtectedRoute>
        }
      >
        <Route
          exact
          path="/"
          element={
            <Home />
          }
        ></Route>
        <Route exact path="/upload/:id" element={<UploadModal />}></Route>
        <Route
          exact
          path="/contact"
          element={
            <Contact />
          }
        ></Route>
        <Route
          exact
          path="/bond-details/:id/edit"
          element={<BondDetailsEdit />}
        ></Route>
        <Route
          exact
          path="/landingpage"
          element={<BondCounselUserLandingPage />}
        ></Route>
        <Route
          exact
          path="/upload-transcript"
          element={<UploadTranscript />}
        ></Route>
      </Route>
      <Route exact path="/login" element={<Login />}></Route>

      <Route exact path="/create-account" element={<CreateAccount />}></Route>
      <Route exact path="/callback" element={<LoginCallback />}></Route>
      <Route exact path="/logout-successful" element={<LogoutSuccess />}></Route>
    </Routes>
  );
};

export default AllRoutes;
